import React, { useEffect, useMemo, useState } from 'react'
import { Button } from 'react-bootstrap'
import { FormattedMessage, injectIntl } from 'react-intl'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { useSelector } from 'react-redux'
import { getSelectedOrFirstCustomer } from '../../../selectors/customers'
import { getIntegratedEmployeesMetaData } from '../../../../app/crud/integration.crud'
import useGroupsFetch from '../../../../app/hooks/useGroupsFetch'
import ImportSettingsModal from '../../../../app/pages/home/modals/ImportSettingsModal'
import Spinner from '../../../../app/partials/content/Spinner'
import { joinGroupsWithSharedMailboxes } from '../../../../app/util/groups.util'

function ImportSettingsButton() {
  const [modalAddEmployeeShow, setModalAddEmployeeShow] = useState(false)
  const [employeesMetaData, setEmployeesMetaData] = useState(null)
  const [loading, setLoading] = useState(false)

  const selectedIntegration = useSelector(({ integrations }) => integrations.selectedIntegration)
  const selectedIntegrationType = selectedIntegration?.IntegrationApplication?.application_name || 'Office365'

  const activatedCustomer = useSelector(getSelectedOrFirstCustomer)

  const { fetchGroups, groups: graphGroups } = useGroupsFetch() // for all graph groups live

  useEffect(() => {
    if (activatedCustomer?.id) {
      // for all graph groups live
      fetchGroups({ customerId: activatedCustomer?.id })
    }
  }, [fetchGroups, activatedCustomer?.id])

  useEffect(() => {
    if (activatedCustomer?.id) {
      getEmployeesMetaData() // eslint-disable-line no-use-before-define
    }
  }, [activatedCustomer]) // eslint-disable-line react-hooks/exhaustive-deps

  const getEmployeesMetaData = async () => {
    setLoading(true)
    try {
      const employeesMeta = await getIntegratedEmployeesMetaData(activatedCustomer?.id, selectedIntegrationType)
      setLoading(false)
      setEmployeesMetaData(employeesMeta?.data)
    } catch (err) {
      setLoading(false)
      console.error(`getIntegratedEmployeesMetaData error`, err)
    }
  }

  const groups = useMemo(
    () =>
      joinGroupsWithSharedMailboxes({
        groups: graphGroups,
        sharedMailboxesGroups: employeesMetaData?.groups,
      }),
    [employeesMetaData?.groups, graphGroups],
  )

  const onAddEmployeeClick = () => {
    setModalAddEmployeeShow(true)
  }

  const modalClose = () => {
    setModalAddEmployeeShow(false)
  }

  // Render button
  return (
    <>
      <Button onClick={() => onAddEmployeeClick()} variant="light" disabled={loading}>
        {loading && <Spinner size="sm" />}
        {!loading && (
          <>
            <LazyLoadImage src="/media/logos/apps/O365.png" style={{ width: 20, height: 20 }} className="mr-3" />
            <FormattedMessage id="ADMINISTRATION.IMPORT_SETTINGS" />
          </>
        )}
      </Button>
      {modalAddEmployeeShow && (
        <ImportSettingsModal
          show={modalAddEmployeeShow}
          onHide={modalClose}
          domainOptions={employeesMetaData?.domains || []}
          rolesOptions={employeesMetaData?.roles || []}
          groupOptions={groups || []}
          licenseOptions={employeesMetaData?.licenseType || []}
          usersOption={employeesMetaData?.users || []}
          selectedIntegrationType={selectedIntegrationType}
          customer={activatedCustomer}
        />
      )}
    </>
  )
}

export default injectIntl(ImportSettingsButton)
